export default function ({ store, redirect }) {
  store.dispatch("application/renewCancelToken");
  if (store.getters["authentication/isAuthorizated"]) {
    return redirect("/");
  }
}
